(function($) {
    $('.specifications__title').on('click', function() {
        $(this).parent().toggleClass("active");
    });
})(jQuery);